import { Badge, cn, formatPercentNoFraction, MetricCard } from "@quortex/front-common"
import {
  type QoEStatusCardProps,
  statusToColor
} from "@/pages/ContentSteering/Segmentation/SegmentationPage/QoEStatusCard"

const QoEStatusCard = ({ overallQoe, className }: QoEStatusCardProps) => (
  <MetricCard className={cn("flex h-full flex-col", className)} title="QoE status">
    <div className="flex flex-col items-start gap-xs">
      <Badge className="uppercase" color={statusToColor[overallQoe.qoeStatus]}>
        {overallQoe.qoeStatus}
      </Badge>
    </div>
    {(overallQoe.qoeStatus === "WARNING" || overallQoe.qoeStatus === "ERROR") && (
      <div className="mt-sm flex flex-col items-start">
        <div className="font-medium text-xs">Impacts</div>
        <div className="flex w-full justify-between">
          <div className="flex basis-1/2 items-center gap-2xs">
            <div className="font-medium">
              {formatPercentNoFraction(overallQoe.impactedViewersPercentage / 100)}
            </div>
            <div className="text-grey-600 text-xs">Viewers</div>
          </div>
          <div className="flex basis-1/2 items-center gap-2xs">
            <div className="font-medium">{overallQoe.impactedSegmentsCount}</div>
            <div className="text-grey-600 text-xs">Segments</div>
          </div>
        </div>
      </div>
    )}
  </MetricCard>
)

export default QoEStatusCard
